/* SnapTech Shopify theme — cart drawer, hero slider, nav, reveals.
 *
 * The cart is Shopify's real cart (/cart/add.js, /cart.js, /cart/change.js), so
 * checkout, discounts, taxes and Cash on Delivery all behave normally. Nothing
 * is stored in localStorage.
 */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.SNAPTECH || {};

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Shopify money values are in cents. */
  function money(cents) {
    var n = (cents || 0) / 100;
    var s = n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0,
                                        maximumFractionDigits: 2 });
    return '$' + s;
  }

  var ICON = {
    plus:  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    check: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    bag:   '<svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg>',
    copy:  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2.4"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
    wa:    '<svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor"><path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.27-.47-2.42-1.49-.9-.8-1.5-1.79-1.68-2.09-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.62-.93-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.03 1.01-1.03 2.45 0 1.45 1.05 2.85 1.2 3.05.15.2 2.08 3.17 5.04 4.44.7.3 1.25.48 1.68.62.72.23 1.37.2 1.89.12.57-.09 1.75-.72 2-1.41.24-.7.24-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.4 9.4 0 0 1-4.78-1.31l-.34-.2-3.56.93.95-3.47-.22-.36a9.38 9.38 0 0 1-1.44-5A9.42 9.42 0 0 1 18.7 5.5a9.34 9.34 0 0 1 2.76 6.66c0 5.18-4.24 9.34-9.42 9.34zM12.05 2A11.35 11.35 0 0 0 .7 13.34c0 2 .52 3.95 1.52 5.67L.6 24.5l5.65-1.48a11.32 11.32 0 0 0 5.8 1.58h.01c6.26 0 11.35-5.09 11.36-11.34A11.28 11.28 0 0 0 20.09 5.3 11.28 11.28 0 0 0 12.05 2z"/></svg>'
  };

  /* ---------------------------------------------------------------- toast */

  var toastTimer;
  function toast(msg) {
    var el = $('#toast');
    if (!el) return;
    el.innerHTML = ICON.check + '<span>' + esc(msg) + '</span>';
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------------------------------------------------------------- drawer */

  function openDrawer() {
    var d = $('#drawer');
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    $('#scrim').classList.add('is-on');
    document.body.classList.add('is-locked');
    var btn = $('#cart-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    $('#drawer-close').focus();
  }

  function closeDrawer() {
    var d = $('#drawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $('#scrim').classList.remove('is-on');
    document.body.classList.remove('is-locked');
    var btn = $('#cart-btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function waOrder(cart) {
    var L = ['*New order — ' + (CFG.shopName || 'SnapTech') + '*', ''];
    cart.items.forEach(function (i) {
      var variant = i.variant_title && i.variant_title !== 'Default Title' ? ' / ' + i.variant_title : '';
      L.push(i.quantity + '× ' + i.product_title + variant + ' — ' + money(i.line_price));
    });
    L.push('', '*Total: ' + money(cart.total_price) + '*');
    return 'https://wa.me/' + CFG.waNumber + '?text=' + encodeURIComponent(L.join('\n'));
  }

  function renderCart(cart) {
    var body = $('#drawer-body');
    var foot = $('#drawer-foot');
    if (!body || !foot) return;

    $$('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-on', cart.item_count > 0);
    });

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="empty">' + ICON.bag +
        '<h4>Nothing here yet</h4>' +
        '<p>Add a laptop and it will show up here. Nothing is charged until it reaches your door.</p>' +
        '<a class="btn btn--primary" href="/collections/all">Browse laptops</a></div>';
      foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var variant = i.variant_title && i.variant_title !== 'Default Title'
        ? '<div class="citem__v">' + esc(i.variant_title) + '</div>' : '';
      return '' +
        '<div class="citem">' +
          '<div class="citem__media">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(i.product_title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<div class="citem__t">' + esc(i.product_title) + '</div>' + variant +
            '<div class="citem__p">' + money(i.final_price) + '</div>' +
          '</div>' +
          '<div class="citem__right">' +
            '<div class="qty">' +
              '<button data-key="' + esc(i.key) + '" data-qty="' + (i.quantity - 1) + '" aria-label="Decrease quantity">' + ICON.minus + '</button>' +
              '<span>' + i.quantity + '</span>' +
              '<button data-key="' + esc(i.key) + '" data-qty="' + (i.quantity + 1) + '" aria-label="Increase quantity">' + ICON.plus + '</button>' +
            '</div>' +
            '<button class="citem__rm" data-key="' + esc(i.key) + '" data-qty="0">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');

    foot.hidden = false;
    foot.innerHTML = '' +
      '<div class="drawer__sums">' +
        '<div><span>Subtotal</span><span class="tabular">' + money(cart.total_price) + '</span></div>' +
        '<div><span>Delivery</span><span class="free">' + (CFG.freeDelivery || 'Included') + '</span></div>' +
        '<div class="is-total"><span>Total</span><b>' + money(cart.total_price) + '</b></div>' +
      '</div>' +
      '<a class="btn btn--primary btn--block" href="/checkout">Checkout' + ICON.arrow + '</a>' +
      '<a class="btn btn--wa btn--block" style="margin-top:.6rem" target="_blank" rel="noopener" href="' +
        esc(waOrder(cart)) + '">' + ICON.wa + ' Order on WhatsApp</a>' +
      (CFG.studentCode
        ? '<div class="drawer__stu">' +
            '<span>' + esc(CFG.studentNote || 'Student? Use this code at checkout.') + '</span>' +
            '<button class="codechip" type="button" data-copy-code="' + esc(CFG.studentCode) + '">' +
              esc(CFG.studentCode) + ICON.copy +
            '</button>' +
          '</div>'
        : '') +
      '<p class="muted" style="font-size:.78rem;text-align:center;margin-top:.85rem">' +
        'Pay on delivery. No card, no deposit.</p>';

    initCopyCodes(foot);

    $$('[data-key]', body).forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.getAttribute('data-key'), +btn.getAttribute('data-qty'));
      });
    });
  }

  function busy(on) {
    var d = $('#drawer');
    if (d) d.classList.toggle('is-busy', !!on);
  }

  function fetchCart() {
    return fetch(CFG.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function changeLine(key, qty) {
    busy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); busy(false); })
      .catch(function () { busy(false); toast('Could not update the cart'); });
  }

  function addToCart(id, qty, name) {
    busy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Sold out'); });
        return fetchCart();
      })
      .then(function () {
        busy(false);
        if (name) toast(name + ' added');
        openDrawer();
      })
      .catch(function (e) {
        busy(false);
        toast(e.message || 'Could not add that');
      });
  }

  /* quick-add forms on product cards, intercepted so the page never reloads */
  function wireQuickAdd(root) {
    $$('[data-quick-add]', root || document).forEach(function (form) {
      if (form.dataset.wired) return;
      form.dataset.wired = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = form.querySelector('[name="id"]').value;
        var card = form.closest('.pcard');
        var name = card ? (card.querySelector('.pcard__title') || {}).textContent : '';
        var btn = form.querySelector('button');
        btn.innerHTML = ICON.check;
        btn.classList.add('is-added');
        addToCart(id, 1, (name || '').trim());
        setTimeout(function () {
          btn.innerHTML = ICON.plus;
          btn.classList.remove('is-added');
        }, 1500);
      });
    });
  }

  /* ---------------------------------------------------------------- nav */

  function initNav() {
    var nav = $('#nav-root');
    if (nav) {
      var onScroll = function () { nav.classList.toggle('is-stuck', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var burger = $('#burger'), sheet = $('#sheet');
    if (burger && sheet) {
      burger.addEventListener('click', function () {
        var open = sheet.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', String(open));
      });
      $$('a', sheet).forEach(function (a) {
        a.addEventListener('click', function () {
          sheet.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    var cartBtn = $('#cart-btn');
    if (cartBtn) cartBtn.addEventListener('click', function () { fetchCart().then(openDrawer); });
    var close = $('#drawer-close');
    if (close) close.addEventListener('click', closeDrawer);
    var scrim = $('#scrim');
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------------------------------------------------------------- reveal */

  function initReveal(root) {
    var items = $$('.rv:not(.is-in)', root || document);
    if (!items.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    /* Anything already in view at load is shown immediately, with the
       transition switched off. Waiting for an observer callback and then
       fading the first screen in over most of a second is the single thing
       that made an already-delivered page feel slow.
       Reads are batched before writes so this stays one layout pass. */
    var vh = window.innerHeight || 800;
    var tops = items.map(function (el) { return el.getBoundingClientRect().top; });
    var rest = [];
    items.forEach(function (el, i) {
      if (tops[i] < vh) {
        el.classList.add('rv--now', 'is-in');
      } else {
        rest.push(el);
      }
    });
    if (!rest.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        if (!en.isIntersecting) {
          /* Already scrolled past without ever intersecting — a restored
             scroll position, a back-navigation or an anchor jump. Show it
             now; otherwise it stays blank until the CSS failsafe, and blank
             content is the worst thing this reveal can do. */
          if (en.boundingClientRect.bottom < 0) {
            el.classList.add('rv--now', 'is-in');
            io.unobserve(el);
          }
          return;
        }
        var sibs = Array.prototype.slice.call(el.parentElement ? el.parentElement.children : []);
        el.style.setProperty('--d', Math.min(sibs.indexOf(el), 5) * 35 + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    rest.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------- hero slider */

  var heroTimer = null;

  function initHeroSlider() {
    var stage = $('#hero-slides');
    if (!stage) return;
    var slides = $$('.hero__slide', stage);
    var dots = $$('#hero-dots button');
    if (slides.length < 2) return;

    clearInterval(heroTimer);
    heroTimer = null;
    var at = 0;

    function show(i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-on', n === at);
        s.setAttribute('aria-hidden', n === at ? 'false' : 'true');
        /* the slides are links now, so the hidden ones must leave the tab order */
        s.setAttribute('tabindex', n === at ? '0' : '-1');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-on', n === at);
        d.setAttribute('aria-selected', String(n === at));
      });
      var tag = $('#hero-pricetag');
      if (tag) {
        var s = slides[at];
        tag.href = s.getAttribute('data-url') || '#';
        $('#hero-name').textContent = s.getAttribute('data-name') || '';
        $('#hero-price').textContent = s.getAttribute('data-price') || '';
      }
    }
    show(0);

    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start() { if (!still && !heroTimer) heroTimer = setInterval(function () { show(at + 1); }, 5000); }
    function stop() { clearInterval(heroTimer); heroTimer = null; }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { stop(); show(n); });
    });
    stage.addEventListener('mouseenter', stop);
    stage.addEventListener('mouseleave', start);
    stage.addEventListener('focusin', stop);

    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
      x0 = null;
      start();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  /* ---------------------------------------------------------------- product page */

  function initProduct() {
    var root = $('#pdp');
    if (!root) return;

    /* gallery */
    var main = $('#gallery-main img');
    $$('.gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.gallery__thumb').forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
        if (main) {
          main.src = t.getAttribute('data-full');
          main.srcset = '';
        }
      });
    });

    /* variants */
    var select = $('#variant-id');
    var opts = $$('.opt');
    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        if (select) select.value = b.getAttribute('data-variant');
        var price = $('#pdp-price');
        if (price) price.textContent = b.getAttribute('data-price');
        var now = $('#opt-now');
        if (now) now.textContent = b.textContent.trim();
        var bb = $('#bb-price');
        if (bb) bb.textContent = b.getAttribute('data-price');
        var wa = $('#pdp-wa');
        if (wa) wa.href = b.getAttribute('data-wa');
        var add = $('#pdp-add');
        if (add) {
          var avail = b.getAttribute('data-available') === 'true';
          add.disabled = !avail;
          add.textContent = avail ? 'Add to cart' : 'Sold out';
        }
        /* swap the gallery photo when this colour has its own image */
        var img = b.getAttribute('data-img');
        if (img && main) {
          main.src = img;
          main.srcset = '';
          $$('.gallery__thumb').forEach(function (x) { x.classList.remove('is-on'); });
        }
      });
    });

    /* add to cart */
    function add() {
      var id = select ? select.value : null;
      if (!id) return;
      var name = ($('#pdp-title') || {}).textContent || '';
      addToCart(id, 1, name.trim());
    }
    var addBtn = $('#pdp-add');
    if (addBtn) addBtn.addEventListener('click', add);
    var bbAdd = $('#bb-add');
    if (bbAdd) bbAdd.addEventListener('click', add);

    /* sticky buy bar on mobile */
    var bar = $('#buybar');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        document.body.classList.toggle('has-buybar', on);
      }, { threshold: 0 }).observe(addBtn);
    }
  }


  /* ---------------------------------------------------------------- spotlight */

  function initSpotlight() {
    var sws = $$('.spot__sw');
    if (!sws.length) return;
    var hidden = $('#spot-variant-id');

    sws.forEach(function (b) {
      b.addEventListener('click', function () {
        sws.forEach(function (x) {
          x.classList.remove('is-on');
          x.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('is-on');
        b.setAttribute('aria-pressed', 'true');

        if (hidden) hidden.value = b.getAttribute('data-variant');
        var price = $('#spot-price');
        if (price) price.textContent = b.getAttribute('data-price');
        var sel = $('#spot-sel');
        if (sel) sel.textContent = b.getAttribute('data-title');
        var vt = $('#spot-variant');
        if (vt) vt.textContent = '· ' + b.getAttribute('data-title');
        var wa = $('#spot-wa');
        if (wa) wa.href = b.getAttribute('data-wa');

        /* swap the photo if this variant has its own */
        var img = $('#spot-img');
        var src = b.getAttribute('data-img');
        if (img && src) { img.src = src; img.srcset = ''; }

        var add = $('#spot-add');
        if (add) {
          var ok = b.getAttribute('data-available') === 'true';
          add.disabled = !ok;
          add.textContent = ok ? 'Add to cart' : 'Sold out';
        }
      });
    });

    var add = $('#spot-add');
    if (add) {
      add.addEventListener('click', function () {
        if (!hidden || !hidden.value) return;
        var t = $('.spot__title');
        addToCart(hidden.value, 1, t ? t.textContent.trim().split('\n')[0] : '');
      });
    }
  }

  /* ---------------------------------------------------------------- collection filters */

  function initShop() {
    var toggle = $('#filters-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = $('#filters').classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
    var sort = $('#sort');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        location.href = u.toString();
      });
    }
    /* Native filter checkboxes. A plain form.submit() would drop sort_by, which
       lives in the URL and not in the form, so rebuild the query instead. */
    var ff = $('#filters');
    if (ff) {
      $$('input[type="checkbox"]', ff).forEach(function (i) {
        if (i.dataset.wired) return;
        i.dataset.wired = '1';
        i.addEventListener('change', applyFilters);
      });
    }
  }

  /* ---------------------------------------------------------------- header search

   * Predictive search rendered by Shopify itself: we ask /search/suggest for the
   * `predictive-search` section and drop the returned HTML in. That way prices
   * come out of Liquid's money filter and the markup stays in one place.
   *
   * With JS off the same form is still a plain GET to /search, so nothing here
   * is load-bearing.
   */

  function initSearch() {
    var form = $('#navsearch');
    if (!form || form.dataset.wired) return;
    form.dataset.wired = '1';

    var input = $('#navsearch-input', form);
    var panel = $('#navsearch-results', form);
    var clear = $('#navsearch-clear', form);
    var base  = CFG.searchUrl || '/search/suggest';
    var timer = null, ctrl = null, opts = [], at = -1;

    function setOpen(on) {
      panel.hidden = !on;
      form.classList.toggle('is-open', on);
      input.setAttribute('aria-expanded', String(on));
      if (!on) {
        at = -1;
        input.removeAttribute('aria-activedescendant');
      }
    }

    function collect() {
      opts = $$('[data-ps-item]', panel);
      opts.forEach(function (o, i) { o.id = 'psr-opt-' + i; });
      at = -1;
    }

    function highlight(step) {
      if (!opts.length) return;
      at = (at + step + opts.length + 1) % (opts.length + 1);
      opts.forEach(function (o, n) { o.classList.toggle('is-on', n === at); });
      if (at < opts.length && at >= 0) {
        input.setAttribute('aria-activedescendant', opts[at].id);
        opts[at].scrollIntoView({ block: 'nearest' });
      } else {
        at = -1;
        input.removeAttribute('aria-activedescendant');
      }
    }

    function run(q) {
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;

      var url = base + '?q=' + encodeURIComponent(q) +
                '&section_id=predictive-search' +
                '&resources[type]=product,collection' +
                '&resources[limit]=6' +
                '&resources[options][unavailable_products]=last';

      form.classList.add('is-busy');
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) {
          if (!r.ok) throw new Error('search failed');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('#shopify-section-predictive-search') ||
                     doc.querySelector('.psr') || doc.body;
          panel.innerHTML = node.innerHTML;
          form.classList.remove('is-busy');
          collect();
          setOpen(true);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          form.classList.remove('is-busy');
          setOpen(false);
        });
    }

    function onType() {
      var q = input.value.trim();
      clear.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) {
        if (ctrl) ctrl.abort();
        setOpen(false);
        return;
      }
      timer = setTimeout(function () { run(q); }, 180);
    }

    input.addEventListener('input', onType);
    input.addEventListener('focus', function () {
      if (panel.innerHTML.trim() && input.value.trim().length >= 2) setOpen(true);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) onType(); else highlight(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(-1); }
      else if (e.key === 'Escape') { setOpen(false); input.blur(); }
      else if (e.key === 'Enter' && at > -1 && opts[at]) { e.preventDefault(); opts[at].click(); }
    });

    clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      setOpen(false);
      input.focus();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) setOpen(false);
    });

    clear.hidden = input.value.trim().length === 0;
  }

  /* ---------------------------------------------------------------- budget slider

   * Two stacked range inputs. Dragging narrows the products already on the page
   * straight away, which is the part that feels fast; releasing hands over to
   * Shopify's real price filter when the Search & Discovery app is installed, so
   * the result survives pagination.
   */

  function initPriceRange() {
    var root = $('[data-prange]');
    if (!root || root.dataset.wired) return;
    root.dataset.wired = '1';

    var lo    = $('[data-prange-lo-input]', root);
    var hi    = $('[data-prange-hi-input]', root);
    var fill  = $('[data-prange-fill]', root);
    var outLo = $('[data-prange-lo]', root);
    var outHi = $('[data-prange-hi]', root);
    var chips = $$('.bchip', root);
    var reset = $('[data-prange-reset]', root);

    var bound  = +root.getAttribute('data-bound-max') || 5000;
    var step   = +root.getAttribute('data-step') || 50;
    var native = root.getAttribute('data-native') === 'true';
    var minName = lo.name;
    var maxName = hi.name;

    var grid    = $('[data-product-grid]');
    var empty   = $('[data-prange-empty]');
    var countEl = $('[data-shop-count]');
    var wordEl  = $('[data-shop-count-word]');
    var cards   = grid ? $$('.pcard[data-price]', grid) : [];
    var singular = wordEl ? wordEl.textContent.replace(/s$/, '') : 'product';

    /* Without the app installed these names would submit a filter Shopify
       cannot honour, so drop them once we know JS is running. */
    if (!native) { lo.removeAttribute('name'); hi.removeAttribute('name'); }

    function pct(v) { return (v / bound) * 100; }

    function paint() {
      var a = +lo.value, b = +hi.value;
      fill.style.left  = pct(a) + '%';
      fill.style.width = (pct(b) - pct(a)) + '%';

      outLo.textContent = '$' + a.toLocaleString('en-US');
      outHi.textContent = '$' + b.toLocaleString('en-US') + (b >= bound ? '+' : '');
      lo.setAttribute('aria-valuetext', '$' + a.toLocaleString('en-US'));
      hi.setAttribute('aria-valuetext', '$' + b.toLocaleString('en-US') + (b >= bound ? ' or more' : ''));

      /* The higher thumb has to win the z-order once both sit at the far left,
         otherwise the top handle becomes impossible to grab. */
      hi.style.zIndex = (b <= step) ? '5' : '3';

      /* Only carry a filter name while the handle is actually narrowing
         something, so an untouched slider adds nothing to the URL. */
      if (native) {
        lo.name = a > 0 ? minName : '';
        hi.name = b < bound ? maxName : '';
      }

      var full = (a === 0 && b >= bound);
      if (reset) reset.hidden = full;
      chips.forEach(function (c) {
        var on = (+c.getAttribute('data-lo') === a && +c.getAttribute('data-hi') === b);
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', String(on));
      });
    }

    function narrow() {
      if (!cards.length) return;
      var a = +lo.value, b = +hi.value;
      var shown = 0;
      cards.forEach(function (c) {
        var p = +c.getAttribute('data-price');
        var ok = p >= a && (b >= bound ? true : p <= b);
        c.classList.toggle('is-filtered', !ok);
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown;
      if (wordEl) wordEl.textContent = shown === 1 ? singular : singular + 's';
      if (empty) empty.hidden = shown !== 0;
      if (grid) grid.classList.toggle('is-empty', shown === 0);
    }

    /* Hand the range over to Shopify so it applies across every page, not just
       the cards currently rendered. Rebuilt from the URL so sort order and any
       other active filter survive. */
    function push() {
      var form = root.closest('form');
      if (!form) return;
      var u = new URL(location.href);
      var fd = new FormData(form);
      var seen = {};
      fd.forEach(function (v, k) { seen[k] = 1; });
      Array.from(u.searchParams.keys()).forEach(function (k) {
        if (k.indexOf('filter.') === 0 || seen[k]) u.searchParams.delete(k);
      });
      fd.forEach(function (v, k) { if (String(v) !== '') u.searchParams.append(k, v); });
      u.searchParams.delete('page');
      location.href = u.toString();
    }

    function commit() {
      if (native) push();
    }

    lo.addEventListener('input', function () {
      lo.value = Math.min(+lo.value, +hi.value - step);
      paint(); narrow();
    });
    hi.addEventListener('input', function () {
      hi.value = Math.max(+hi.value, +lo.value + step);
      paint(); narrow();
    });
    lo.addEventListener('change', commit);
    hi.addEventListener('change', commit);

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        lo.value = c.getAttribute('data-lo');
        hi.value = Math.min(+c.getAttribute('data-hi'), bound);
        paint(); narrow(); commit();
      });
    });

    $$('[data-prange-reset]').forEach(function (b) {
      b.addEventListener('click', function () {
        lo.value = 0;
        hi.value = bound;
        paint(); narrow(); commit();
      });
    });

    /* A visitor can arrive with a budget already chosen — the home page "Under
       $700" button links straight here with a price ceiling. With the Search &
       Discovery app installed Shopify has already filtered server-side and Liquid
       positioned the handles. Without it the parameter would be ignored and the
       button would appear to do nothing, so honour it here too: set the handles
       and narrow the page. Combined with price-ascending sort, page one is the
       cheap end of the catalogue, which is what the label promises. */
    if (!native) {
      var q = new URL(location.href).searchParams;
      var qLo = parseInt(q.get('filter.v.price.gte'), 10);
      var qHi = parseInt(q.get('filter.v.price.lte'), 10);
      if (!isNaN(qLo)) lo.value = Math.max(0, Math.min(qLo, bound - step));
      if (!isNaN(qHi)) hi.value = Math.max(step, Math.min(qHi, bound));
    }

    paint();
    narrow();
  }

  /* ------------------------------------------------------- filters + copy code */

  function applyFilters() {
    var ff = $('#filters');
    if (!ff) return;
    var u = new URL(location.href);
    var fd = new FormData(ff);
    var seen = {};
    fd.forEach(function (v, k) { seen[k] = 1; });
    Array.from(u.searchParams.keys()).forEach(function (k) {
      if (k.indexOf('filter.') === 0 || seen[k]) u.searchParams.delete(k);
    });
    fd.forEach(function (v, k) { if (String(v) !== '') u.searchParams.append(k, v); });
    u.searchParams.delete('page');
    location.href = u.toString();
  }

  function initCopyCodes(root) {
    $$('[data-copy-code]', root || document).forEach(function (b) {
      if (b.dataset.wired) return;
      b.dataset.wired = '1';
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-copy-code');

        function done() {
          b.classList.add('is-copied');
          toast(code + ' copied');
          setTimeout(function () { b.classList.remove('is-copied'); }, 1800);
        }
        function fallback() {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); }
          catch (e) { toast('Your code is ' + code); }
          document.body.removeChild(ta);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, fallback);
        } else {
          fallback();
        }
      });
    });
  }

  /* ---------------------------------------------------------------- boot */

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initHeroSlider();
    initSpotlight();
    initProduct();
    initShop();
    initSearch();
    initPriceRange();
    initCopyCodes();
    initReveal();
    wireQuickAdd();
    fetchCart();
  });

  /* let the theme editor re-init sections as they are edited */
  document.addEventListener('shopify:section:load', function () {
    initHeroSlider();
    initSpotlight();
    initProduct();
    initShop();
    initPriceRange();
    initCopyCodes();
    initReveal();
    wireQuickAdd();
  });
})();
